import Vue from 'vue'
import Vuex from 'vuex'
import createMutationsSharer from 'vuex-shared-mutations'
import { createModule } from 'vuex-toast'
import auth from './modules/auth'
import companies from './modules/companies'
import hints from './modules/hints'
import scripts from './modules/scripts'
import sidebar from './modules/sidebar'
import settings from './modules/settings'
import users from './modules/users'
import knowledge from './modules/knowledge'
import recordings from './modules/recordings'
import phrases from './modules/phrases'
import scriptTemplates from './modules/script-templates'
import localStorage from './modules/local-storage'
import Products from './modules/products'
import SavedFilters from './modules/user-filters'
import scheme from './modules/scheme'
import { SHAREABLE_MUTATIONS } from './mutations'
import { isProduction } from '@/constants/enviroment'

import type { RootState } from './state'

Vue.use(Vuex)

export default new Vuex.Store<RootState>({
  strict: !isProduction,
  modules: {
    auth,
    companies,
    scripts,
    sidebar,
    settings,
    hints,
    users,
    knowledge,
    recordings,
    phrases,
    scriptTemplates,
    localStorage,
    Products,
    SavedFilters,
    scheme,
    toast: createModule({
      dismissAfter: 5000,
    }),
  },
  plugins: [createMutationsSharer({ predicate: SHAREABLE_MUTATIONS })],
})
